// extracted by mini-css-extract-plugin
export default {"flag":"LanguageDropdown_flag__10-lB"};